























































import { defineComponent, ref, onMounted, nextTick, computed } from '@vue/composition-api'
import { UsersApi } from '@/services/ie-microservice-openapi'
import { logError } from '@/util/sentry'
import { useLoading } from '@/mixins/v3/loading'
//@ts-ignore
import Modal from '@/components/Modal.vue'
import { alertSuccess, alertFailure } from '@/mixins/v3/alerts'

export default defineComponent({
  name: 'VerificationCodeModal',
  components: {
    Modal,
  },
  props: {
    email: {
      type: String,
    },
    showVerificationModal: {
      type: Boolean,
      required: true,
    },
    userID: {
      type: Number,
    },
  },
  setup(props, context) {
    const otpInputs = ref(Array(6).fill(''))
    const otpInputRefs = ref<HTMLInputElement[]>([])
    const { isLoading, runPromise } = useLoading()
    const feedback = ref('')

    const nextDisabled = computed(() => otpInputs.value.some((input) => input === ''))

    const closeModal = () => {
      context.emit('close')
    }

    const handleInput = (index: number) => {
      // validation code will be digits
      otpInputs.value[index] = otpInputs.value[index].replace(/[^0-9]/g, '')

      if (otpInputs.value[index].length === 1 && otpInputRefs.value[index + 1]) {
        otpInputRefs.value[index + 1].focus()
      }
    }

    const handleBackspace = (index: number, event: KeyboardEvent) => {
      if (
        event.key === 'Backspace' &&
        otpInputs.value[index] === '' &&
        otpInputRefs.value[index - 1]
      ) {
        otpInputRefs.value[index - 1].focus()
      }
    }

    const handlePaste = (event: ClipboardEvent) => {
      event.preventDefault()
      const clipboardData = event.clipboardData?.getData('text') || ''

      const digitsOnly = clipboardData.replace(/[^0-9]/g, '')

      if (digitsOnly.length > 0) {
        otpInputs.value = Array(otpInputs.value.length).fill('')
        digitsOnly.split('').forEach((char, index) => {
          if (index < otpInputs.value.length) {
            otpInputs.value[index] = char
            otpInputRefs.value[index]?.focus()
          }
        })
      }
    }

    const verifyCode = () => {
      const fullCode = otpInputs.value.join('')

      runPromise(async () => {
        try {
          if (props.userID) {
            const res = await new UsersApi().verifyUserCode(props.userID, fullCode)
            if (res.status === 200) {
              alertSuccess(context, 'Email verification successful!')
              closeModal()
            }
          }
        } catch (err) {
          feedback.value =
            'Email verification failed. Please try again or resend verification link.'
          logError('failed to verify email', { extras: { error: err } })
        }
      })
    }

    const resendCode = async () => {
      try {
        feedback.value = ''
        props.userID && (await new UsersApi().resendUserVerifyEmail(props.userID))
        otpInputs.value = Array(otpInputs.value.length).fill('')
        alertSuccess(context, 'Verification code resent.')
      } catch (err) {
        alertFailure(context, 'Failed to resend verification code. Please try again.')
        logError('failed to resend verification code', { extras: { error: err } })
      }
    }

    onMounted(() => {
      if (props.showVerificationModal) {
        nextTick(() => {
          setTimeout(() => {
            otpInputRefs.value[0]?.focus()
          }, 500)
        })
      }
    })

    return {
      otpInputs,
      otpInputRefs,
      handleInput,
      handleBackspace,
      handlePaste,
      verifyCode,
      resendCode,
      isLoading,
      nextDisabled,
      feedback,
    }
  },
})
